import { CreateBase, Form, useGetIdentity, type MutationMode } from "ra-core";
import { useSearchParams } from "react-router";
import { Card, CardContent } from "@/components/ui/card";

import { FormToolbar } from "../layout/FormToolbar";
import { ProspectInputs } from "./ProspectInputs";
import {
  cleanupProspectForCreate,
  defaultEmails,
  defaultPhones,
  prefillFromParams,
} from "./prospectModel";

export const ProspectCreate = ({
  mutationMode,
}: {
  mutationMode?: MutationMode;
}) => {
  const { identity } = useGetIdentity();
  const [searchParams] = useSearchParams();
  // "Send to CRM" deep link from the map tool prefills fields via query params.
  const prefill = prefillFromParams(searchParams);

  return (
    <CreateBase
      redirect="show"
      transform={cleanupProspectForCreate}
      mutationMode={mutationMode}
    >
      <div className="mt-2 flex">
        <div className="flex-1">
          <Form
            defaultValues={{
              sales_id: identity?.id,
              stage: "Researching",
              phones: defaultPhones,
              emails: defaultEmails,
              ...prefill,
            }}
          >
            <Card>
              <CardContent>
                <ProspectInputs />
                <FormToolbar />
              </CardContent>
            </Card>
          </Form>
        </div>
      </div>
    </CreateBase>
  );
};
